import { EngineConfiguration } from '~/Scene/Viewer/engineConfiguration';
import { PointofviewsManager } from '~/Scene/Pointofview/pointofviewsManager';
import { RenderQuality } from '~/Scene/System/systemQuality';
import { CanvasGridPlane } from '~/Services/Studio/Canvas/canvasGridPlane';
import { UiDragAnimation } from '~/Scene/Ui/uiDragAnimation';
import { UiCameraRotate } from '~/Scene/Ui/uiCameraRotate';
import { MaterialEvent } from '~/Scene/Tool/toolMaterial';

// Random Element just to start engine
export const container = document.body.children[0] as HTMLElement;
// @ts-ignore
export const _engine = new EngineConfiguration({ container });
_engine.buildAllClass()
export const _system = _engine.system;
_system.setNeedProcess(false);
_system.setLimitFPS(true);
_system.setQuality(RenderQuality.High);

export const _mouseCatcher = _engine.mouseCatcher;
export const _contentsManager = _engine.contentsManager;
export const _environment = _engine.sceneryEvironment;
export const _pipeline = _engine.sceneryPipeline;
export const _camera = _engine.sceneryCamera;

const { sceneContainer } = _engine;
export const _pointofviewsManager = new PointofviewsManager();
export const _uiDragAnimation = new UiDragAnimation(
    _system,
    sceneContainer,
    _camera
);
export const _uiCameraRotate = new UiCameraRotate(_system);
export const canvasGridPlane = new CanvasGridPlane(_system);

export function disposeProject(): void {
    // _contentsManager.destroyContents();
    _system.pauseRender();
}

// EVENTS
document.addEventListener('mouseleave', () => {
    _system.pauseRender();
});
document.addEventListener('mouseenter', () => {
    _system.startRender();
});
document.addEventListener('focus', () => {
    _system.startRender();
});

const { toolMaterial } = _system;
toolMaterial.on(MaterialEvent.RemoveFromAll, (materialOptions) => {
    const models = _contentsManager.getContentModels();
    models.forEach((model) => {
        model.removeMaterialFromVariants(materialOptions.key);
    });
});
